import React, { useEffect, useState } from 'react';
import { Button, ListGroup, Card, Modal } from 'react-bootstrap';
import { ArrowLeft } from 'react-bootstrap-icons';

const AdminProjectsTab = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [applicants, setApplicants] = useState([]);
  const [showApplicants, setShowApplicants] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [showApplicantModal, setShowApplicantModal] = useState(false);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [technologies, setTechnologies] = useState('');
  const [category, setCategory] = useState('');
  const [startDate, setStartDate] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');


  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${API_URL}/api/admin/projects`)
      .then(res => res.json())
      .then(data => setProjects(data))
      .catch(err => console.error('Error fetching projects:', err));
  }, [API_URL]);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setShowApplicants(false);
  };

  const handleBack = () => {
    setSelectedProject(null);
    setApplicants([]);
    setShowApplicants(false);
  };

  const fetchApplicants = async (projectId) => {
    try {
      const res = await fetch(`${API_URL}/api/admin/projects/${projectId}/applicants`);
      const data = await res.json();
      if (data && Array.isArray(data.applicants)) {
        setApplicants(data.applicants);
        setShowApplicants(true);
      } else {
        setApplicants([]);
        setShowApplicants(false);
      }
    } catch (err) {
      console.error('Failed to fetch applicants:', err);
      setApplicants([]);
      setShowApplicants(false);
    }
  };

  const fetchApplicantDetails = async (userId) => {
    try {
      const res = await fetch(`${API_URL}/api/admin/project-applicant/${userId}`);
      const data = await res.json();
      setSelectedApplicant(data);
      setShowApplicantModal(true);
    } catch (err) {
      console.error('Error fetching applicant details:', err);
    }
  };

  return (
    <div>
      {/* {!selectedProject && (
        <>
          <h4 className="mb-3">All Projects</h4>
          <ListGroup>
            {projects.map(p => (
              <ListGroup.Item
                key={p._id}
                action
                onClick={() => handleProjectClick(p)}
              >
                <strong>{p.title}</strong>
                <div className="text-muted" style={{ fontSize: '0.9em' }}>{p.category?.join(', ')}</div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </>
      )} */}

      {!selectedProject && (
          <>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4>All Projects</h4>
              <Button variant="primary" onClick={() => setShowCreateModal(true)}>
                + Create Project
              </Button>
            </div>
            <ListGroup>
              {projects.map(p => (
                <ListGroup.Item
                  key={p._id}
                  action
                  onClick={() => handleProjectClick(p)}
                >
                  <strong>{p.title}</strong>
                  <div className="text-muted" style={{ fontSize: '0.9em' }}>{p.category?.join(', ')}</div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </>
        )}


      {selectedProject && !showApplicants && (
        <>
          <Button variant="link" className="mb-3" onClick={handleBack}>
            <ArrowLeft /> Back to Projects
          </Button>

          <Card className="p-3 shadow-sm">
            <h5>{selectedProject.title}</h5>
            <p><strong>Description:</strong> {selectedProject.description}</p>
            <p><strong>Technologies:</strong> {selectedProject.technologies?.join(', ')}</p>
            <p><strong>Category:</strong> {selectedProject.category?.join(', ')}</p>
            <p><strong>Start Date:</strong> {new Date(selectedProject.start_date).toLocaleDateString()}</p>
            <Button onClick={() => fetchApplicants(selectedProject._id)}>Applicants</Button>
          </Card>
        </>
      )}

      {selectedProject && showApplicants && (
        <>
          <Button variant="link" className="mb-3" onClick={() => setShowApplicants(false)}>
            <ArrowLeft /> Back to Project Details
          </Button>

          <Card className="p-3 shadow-sm">
            <h5>Applicants for {selectedProject.title}</h5>
            <ListGroup>
              {applicants.map((a, i) => (
                <ListGroup.Item key={i} action onClick={() => fetchApplicantDetails(a.userId)}>
                  <strong>{a.name}</strong> ({a.role})
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card>
        </>
      )}

      <Modal show={showApplicantModal} onHide={() => setShowApplicantModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Applicant Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedApplicant ? (
            <div>
              <p><strong>Name:</strong> {selectedApplicant.first_name} {selectedApplicant.last_name}</p>
              <p><strong>Email:</strong> {selectedApplicant.email}</p>
              <p><strong>Phone:</strong> {selectedApplicant.phone}</p>
              <p><strong>Role:</strong> {selectedApplicant.role}</p>
              <p><strong>Country:</strong> {selectedApplicant.country}</p>
              <p><strong>Gender:</strong> {selectedApplicant.gender}</p>
              <hr />
              <h6>Qualifications</h6>
              <ul>
                {selectedApplicant.qualification?.map((q, idx) => (
                  <li key={idx}>{q.course} from {q.university} ({q.year})</li>
                ))}
              </ul>
              <h6>Experience</h6>
              <ul>
                {selectedApplicant.experience?.map((e, idx) => (
                  <li key={idx}>{e.role} at {e.company} ({e.from} - {e.to})</li>
                ))}
              </ul>
              {/* {selectedApplicant.cv && (
                <a
                  href={`data:${selectedApplicant.cv.contentType};base64,${selectedApplicant.cv.data}`}
                  download={`${selectedApplicant.first_name}_cv.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary mt-2"
                >
                  Download CV
                </a>
              )} */}

              {selectedApplicant.cv && selectedApplicant.cv.data && (
                    <>
                        <h6 className="mt-4">CV Preview</h6>
                        <embed
                        src={`data:${selectedApplicant.cv.contentType};base64,${btoa(
                            new Uint8Array(selectedApplicant.cv.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        )}`}
                        type="application/pdf"
                        width="100%"
                        height="400px"
                        />
                    </>
                    )}

                    {selectedApplicant.certificate && selectedApplicant.certificate.data && (
                    <>
                        <h6 className="mt-4">Certificate Preview</h6>
                        <embed
                        src={`data:${selectedApplicant.certificate.contentType};base64,${btoa(
                            new Uint8Array(selectedApplicant.certificate.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        )}`}
                        type="application/pdf"
                        width="100%"
                        height="400px"
                        />
                    </>
                    )}


            </div>
          ) : (
            <p>Loading applicant details...</p>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create New Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={e => setTitle(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                value={description}
                onChange={e => setDescription(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Technologies (comma separated)</label>
              <input
                type="text"
                className="form-control"
                value={technologies}
                onChange={e => setTechnologies(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Category (comma separated)</label>
              <input
                type="text"
                className="form-control"
                value={category}
                onChange={e => setCategory(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={e => setStartDate(e.target.value)}
              />
            </div>
          </form>
          {error && <div className="text-danger mt-2">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              setCreating(true);
              setError('');
              const payload = {
                title,
                description,
                technologies: technologies.split(',').map(t => t.trim()).filter(Boolean),
                category: category.split(',').map(c => c.trim()).filter(Boolean),
                start_date: startDate
              };
              try {
                const res = await fetch(`${API_URL}/api/admin/create-project`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(payload)
                });
                const data = await res.json();
                if (res.ok) {
                  setShowCreateModal(false);
                  setTitle('');
                  setDescription('');
                  setTechnologies('');
                  setCategory('');
                  setStartDate('');
                  // Refresh projects
                  fetch(`${API_URL}/api/admin/projects`)
                    .then(res => res.json())
                    .then(data => setProjects(data));
                } else {
                  setError(data.error || 'Failed to create project.');
                }
              } catch (err) {
                setError('Network error. Please try again.');
              } finally {
                setCreating(false);
              }
            }}
            disabled={creating}
          >
            {creating ? 'Creating...' : 'Create Project'}
          </Button>
        </Modal.Footer>
      </Modal>


    </div>
  );
};

export default AdminProjectsTab;
